import { Component } from 'react';
import _ from 'lodash';
import { getCountry } from './CountryProvider';

export class FormattedName extends Component {
    renderFullName() {
        const { firstName, lastName, possessive } = this.props;

        if (possessive) {
            return this.calculatePossessiveName(firstName, lastName);
        }

        return `${firstName} ${lastName}`;
    }

    calculatePossessiveName(...names) {
        const lastLetter = names[names.length - 1].slice(-1);
        const country = getCountry();
        if (names.length === 1) {
            if (lastLetter === 's') {
                return `${names[0]}'`;
            } else {
                if (country === 'DE') {
                    return `${names[0]}s`;
                } else return `${names[0]}'s`;
            }
        }

        return _.map(names, (name, index) => {
            if (names.length === index + 1) {
                if (lastLetter === 's') {
                    return `${name}'`;
                }
                return `${name}'s`;
            } else {
                return `${name} `;
            }
        });
    }

    renderFirstName() {
        const { firstName, possessive } = this.props;

        if (possessive) {
            return this.calculatePossessiveName(firstName);
        }

        return firstName;
    }

    renderLastName() {
        const { lastName, possessive } = this.props;

        if (possessive) {
            return this.calculatePossessiveName(lastName);
        }

        return lastName;
    }

    renderName() {
        const { firstName, lastName } = this.props;

        if (firstName && lastName) {
            return this.renderFullName();
        } else if (firstName && !lastName) {
            return this.renderFirstName();
        } else if (!firstName && lastName) {
            return this.renderLastName();
        } else {
            return null;
        }
    }

    render() {
        const name = this.renderName();

        return (
            <span className="fs-exclude" data-testid="formatted-name">
                {name}
            </span>
        );
    }
}
